import script from "./NotificationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBar.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBar.vue?vue&type=style&index=0&id=2983bc8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2983bc8a"]])

export default __exports__